module.exports = __webpack_public_path__ + "static/banner-moc-1-1-6bbbb2bdece881e07396596742ae0fb5.png";